import { Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { AuthProvider } from './contexts/AuthContext'
import { DCProvider } from './contexts/DCContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import DCUploadPage from './pages/DCUploadPage'
import DCItemMappingPage from './pages/DCItemMappingPage'
import DCComparisonPage from './pages/DCComparisonPage'
import DCSettingsPage from './pages/DCSettingsPage'
import DCDashboard from './pages/DCDashboard'
import DCOrdersPage from './pages/DCOrdersPage'
import DCEligibleItemsPage from './pages/DCEligibleItemsPage'
import DCManagedItemsPage from './pages/DCManagedItemsPage'
import DCOrderCreatePage from './pages/DCOrderCreatePage'
import DCOrderDetailPage from './pages/DCOrderDetailPage'
import DCPurchasesPage from './pages/DCPurchasesPage'
import DCPurchaseUploadPage from './pages/DCPurchaseUploadPage'
import DCManualPurchaseEntryPage from './pages/DCManualPurchaseEntryPage'
import DCPurchaseDetailPage from './pages/DCPurchaseDetailPage'
import DCInventoryPage from './pages/DCInventoryPage'
import DCTransfersPage from './pages/DCTransfersPage'
import DCTransferCreatePage from './pages/DCTransferCreatePage'
import DCTransferDetailPage from './pages/DCTransferDetailPage'
import LoginPage from './pages/LoginPage'

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <DCProvider>
                <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<DCDashboard />} />
                      <Route path="/upload" element={<DCUploadPage />} />
                      <Route path="/mapping/:uploadId" element={<DCItemMappingPage />} />
                      <Route path="/comparison" element={<DCComparisonPage />} />
                      <Route path="/orders" element={<DCOrdersPage />} />
                      <Route path="/orders/eligible" element={<DCEligibleItemsPage />} />
                      <Route path="/orders/managed" element={<DCManagedItemsPage />} />
                      <Route path="/orders/create" element={<DCOrderCreatePage />} />
                      <Route path="/orders/:orderId" element={<DCOrderDetailPage />} />
                      <Route path="/purchases" element={<DCPurchasesPage />} />
                      <Route path="/purchases/upload" element={<DCPurchaseUploadPage />} />
                      <Route path="/purchases/manual" element={<DCManualPurchaseEntryPage />} />
                      <Route path="/purchases/:id" element={<DCPurchaseDetailPage />} />
                      <Route path="/inventory" element={<DCInventoryPage />} />
                      <Route path="/transfers" element={<DCTransfersPage />} />
                      <Route path="/transfers/create" element={<DCTransferCreatePage />} />
                      <Route path="/transfers/:id" element={<DCTransferDetailPage />} />
                      <Route path="/settings" element={<DCSettingsPage />} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </Layout>
                </Box>
              </DCProvider>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

export default App
